import {
  Button,
  ErrorMessage,
  InputField,
  Spinner,
  SuccessPopup,
} from "@/common/components";
import { useContext, useEffect, useState } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  useSaveRecordKeepingSystemMutation,
  useUpdateRecordKeepingSystemMutation,
} from "@/service/AdminService";
import { validate } from "@/utils/Validations";

const RecordKeeperDetails = () => {
  const {
    setNavHeader,
    location,
    debounceState,
    debounceErrors,
    cancel,
    labels,
    setPageHeader,
  } = useContext(PrivateContext);
  const [recordKeeperData, setRecordKeeperData] = useState({});
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [updateRecordKeeperApi, { isLoading: isFetching, error }] =
    useUpdateRecordKeepingSystemMutation();
  const [saveRecordKeeperApi, { isLoading: isFetching1, error: error1 }] =
    useSaveRecordKeepingSystemMutation();

  const onChange = async (value, state) => {
    debounceState({ ...recordKeeperData, [state]: value }, setRecordKeeperData);
    debounceErrors(
      { ...errors, [state]: await validate(value, [state]) },
      setErrors
    );
  };

  const errorProps = (state) => {
    return {
      value: recordKeeperData[state],
      error: errors[state],
      touched: touched[state],
      touch: () => setTouched({ ...touched, [state]: true }),
    };
  };

  const checkDisabled = () => {
    return (
      Object.values(errors).some((val) => val) ||
      !recordKeeperData.recordkeeperName ||
      !recordKeeperData.recordkeepingName
    );
  };

  const addOrUpdateRKDetails = () => {
    // Update
    if (location?.state) {
      recordKeeperData["lastMntDateTime"] = location?.state.lastMntDateTime;
      recordKeeperData["lastMntOpId"] = location?.state.lastMntOpId;
      recordKeeperData["id"] = location?.state.id;
      updateRecordKeeperApi(recordKeeperData)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
    // Add New
    else {
      saveRecordKeeperApi(recordKeeperData)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
  };

  useEffect(() => {
    setPageHeader(labels?.recordKeeper?.rkDetails);
    setNavHeader(labels?.recordKeeper?.recordKeeper);

    if (location?.state?.id) {
      setRecordKeeperData(location.state);
    }
  }, []);
  return (
    <section className="container-medium py-5">
      {(isFetching || isFetching1) && <Spinner />}
      <ErrorMessage error={error || error1} />
      {location?.state && (
        <div className="mb-3">
          {labels?.recordKeeper?.transmitterID} {recordKeeperData?.id}
        </div>
      )}

      <InputField
        id="name"
        label={labels?.recordKeeper?.name}
        wrapperClassName=""
        maxLength="35"
        change={(e) => onChange(e, "recordkeeperName")}
        {...errorProps("recordkeeperName")}
      />
      <InputField
        id="hostName"
        label={labels?.recordKeeper?.rkServerHost}
        wrapperClassName=""
        change={(e) => onChange(e, "serverHostName")}
        {...errorProps("serverHostName")}
      />
      <InputField
        id="port"
        type="number"
        label={labels?.recordKeeper?.rkHostPort}
        wrapperClassName="col-md-4"
        maxLength="35"
        change={(e) => onChange(e, "hostPortNumber")}
        {...errorProps("hostPortNumber")}
      />
      <InputField
        id="recordKeepingSystem"
        label={labels?.recordKeeper?.rkSystemMandatory}
        wrapperClassName=""
        maxLength="35"
        change={(e) => onChange(e, "recordkeepingName")}
        {...errorProps("recordkeepingName")}
      />

      <div className="d-flex flex-row gap-1 justify-content-end mt-5">
        <Button
          id="cancel"
          type="secondary"
          text={labels?.recordKeeper?.cancel}
          wrapperClassName="col-md-4 col-6"
          click={cancel}
        />
        <Button
          id="done"
          text={
            location?.state
              ? labels?.recordKeeper?.update
              : labels?.recordKeeper?.submit
          }
          wrapperClassName="col-md-4 col-6"
          disabled={checkDisabled()}
          click={addOrUpdateRKDetails}
        />
      </div>
      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.recordKeeper?.continue}
        click={cancel}
        body={labels?.recordKeeper?.requestCompleted}
      />
    </section>
  );
};

export default RecordKeeperDetails;
